import styles from "./RekomLoadingPage.module.scss";
import RekomLoadingAnimation from "./components/RekomLoadingAnimation/RekomLoadingAnimation";
import RekomLoadingPageProps from "./RekomLoadingPageProps.interface";

import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import combineClasses from "helpers/combine-classes";
import isBrowserContext from "helpers/isBrowserContext";
import RekomEventLoadingAnimation from "./components/RekomEventLoadingAnimation/RekomEventLoadingAnimation";

const RekomLoadingPage: FunctionComponent<RekomLoadingPageProps> = (props) => {
  const [websiteType, setWebsiteType] = useState<string>("");
  const [viewState, setViewState] = useState<string>("NONE");
  const [timeLeft, setTimeLeft] = useState<number>(0);

  const websiteTypeClass = websiteType
    ? styles[`website_${websiteType}`]
    : undefined;
  const isRunningClass = !["NONE", "ENDING", "ENDED"].includes(viewState)
    ? styles.is_running
    : undefined;
  const isEndingClass = viewState === "ENDING" ? styles.is_ending : undefined;

  // Start

  useEffect(() => {
    if (isBrowserContext() && window?.location?.href) {
      const isRekomUrl =
        window.location.origin === "https://www.rekomgroup.com" ||
        window.location.origin === "https://rekomgroup.com" ||
        window.location.href.indexOf("http://localhost:3000/rekomgroup") >= 0 ||
        window.location.href.indexOf(
          "https://stage.rekom.frontend.heyday.dk/group"
        ) >= 0 ||
        window.location.href.indexOf(
          "https://production.rekom.frontend.heyday.dk/rekomgroup"
        ) >= 0;
      const isRekomEventUrl =
        window.location.origin === "https://rekomevent.dk" ||
        window.location.origin ===
          "https://stage.rekom.frontend.heyday.dk/rekomevent" || window.location.href.indexOf(
            "https://stage.rekom.frontend.heyday.dk/rekomevent"
          ) >= 0 ||
        window.location.href.indexOf("http://localhost:3000/rekomevent") >= 0;

      // REKOM Group
      if (isRekomUrl) {
        setWebsiteType("REKOM");
        setViewState("RUNNING");
        setTimeLeft(1800); // TODO: Improve to have callback from animation
      } 
      else if (isRekomEventUrl) {
        setWebsiteType("REKOMEVENT");
        setViewState("RUNNING");
        setTimeLeft(2500);
      }

      // Other
      else {
        setWebsiteType("OTHER");
        setViewState("RUNNING");
        setTimeLeft(0);
      }
    }
  }, []);

  // Callback

  useEffect(() => {
    if (props.viewState === "LOADED") {
      setTimeout(() => {
        setViewState("ENDING");
      }, timeLeft);
    }
  }, [props.viewState]);

  // Countdown

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((timer) => timer - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Finally

  useEffect(() => {
    if (viewState === "ENDING") {
      setTimeout(() => {
        setViewState("ENDED");
      }, 500);
    }
  }, [viewState]);

  return (
    <Fragment>
      {isBrowserContext() ? (
        <section
          className={combineClasses(
            styles.wrapper,
            websiteTypeClass,
            isRunningClass,
            isEndingClass
          )}
        >
          {websiteType === "REKOM" && viewState === "RUNNING" ? (
            <RekomLoadingAnimation />
          ) : null}

          {websiteType === "REKOMEVENT" && viewState === "RUNNING" ? (
            <RekomEventLoadingAnimation />
          ) : null}

          {websiteType === "OTHER" && viewState === "RUNNING" ? (
            <div className={styles.app_loading_wrapper}>
              <div className={styles.app_loading_spinner}></div>
            </div>
          ) : null}
        </section>
      ) : null}
    </Fragment>
  );
};

export default RekomLoadingPage;
